import { Controller, useForm } from 'react-hook-form';
import axios from 'axios';
import {
  EventReqDtos,
  HospitalCenterReqDto,
  LeadsDto,
  MtContinentDto,
} from '../../../api/interfaces/LeadsDto';
import { useEffect, useRef, useState } from 'react';
import { getService, postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import moment from 'moment';
import { useLoader } from '../../../Loader/LoaderContext';
import {
  LeadsContinents,
  ProposalPitched,
} from '../../../api/interfaces/LeadsContinent';
import { mtCountryDto, mtCurrencyDto } from '../../../api/interfaces/addUser';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useToaster } from '../../../Toaster/Toaster';
import ConfirmationModal from '../Modals/confirmationPopup';
import Sucesspopup from '../Modals/SucessPopup';
import {
  getCurrencySymbol,
  getNamesOfEvents,
  getRoleDisplayName,
} from '../../../utility/RolesUtility';
import Select from 'react-select';
const AddProposal: React.FC = () => {
  const [state, mtState] = useState([]);
  const [mtCurrencyData, setMtCurrency] = useState<mtCurrencyDto[]>([]);
  const [currencyCodes, setSelectedCurrency] = useState('');
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('bookingId');
  const [isEditMode, setIsEditMode] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const getLocalDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    const day = String(today.getDate()).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}-${day}`; // Format YYYY-MM-DD
  };

  const todayDate = getLocalDate();
  const [selectedTypes, setSelectedType] = useState('PAID');
  const [selectedDate, setSelectedDate] = useState(today);
  const [startDate, setStartDate] = useState(today); // Initialize startDate state
  const [endDate, setEndDate] = useState('');
  const [endDate1, setEndDate1] = useState('');
  const [endDate2, setEndDate2] = useState('');
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    trigger,
    clearErrors,
    reset,
    formState: { errors, isValid, isSubmitting, touchedFields },
  } = useForm<LeadsDto>({
    mode: 'onChange',
    defaultValues: {
      bookingDate: today,
      eventReqDtos: [
        {
          name: '',
          startDate: '',
          endDate: '',
          contactPersonName: '',
          contactPersonEmail: '',
          phoneNo: '',
          venue: '',
          type: '',
          mtCountryDto: { id: 0, name: '', isoCode: '', code: '' },
        },
      ],
    },
  });
  useEffect(() => {
    if (bookingId) {
      setIsEditMode(true);
    } else {
      setIsEditMode(false);
    }
  }, [bookingId]);
  useEffect(() => {
    setValue('bookingDate', selectedDate); // ✅ Set default value
    trigger('bookingDate'); // ✅ Ensure validation runs
  }, [setValue, trigger]);
  const [formData, setFormData] = useState({
    proposalId: 0,
    isHospitalProfiling: false,
    isCenterListing: false,
    isBannerAds: false,
    isEmailMarketing: false,
    isNewsLetterAds: false,
    isContentMarketing: false,
    printAdd: 0,
    isPrintAd: false,
    isHospitalProfilingExist: false,
    isCompanyProfilingExist: false,
    // isEventProfiling: false,
    isCompanyProfiling: false,
    isEventListing: false,
    noOfPrintAds: 0,
    noOfNewsBanners: 0,
    noOfPosts: 0,
    noOfEdms: 0,
    noOfRecipients: 0,
    noOfBanners: 0,
    value: 0,
    eventIdList: [],
    // Add other checkboxes as needed
  });
  const [mtCountryDataLoaded, setMtCountryDataLoaded] = useState(false);
  const [selectedContinent, setSelectedContinent] = useState<string>('');
  const [selectedPitched, setSelectedPitched] = useState<string>('');
  const [selectedContry, setSelectedContry] = useState<string>('');
  const { showToast } = useToaster();
  const userId = searchParams.get('appUserId');
  const leadId = searchParams.get('leadId');
  const convertBookForm = searchParams.get('convertBookForm');
  const proposalFrom = searchParams.get('proposalFrom');
  const [touched, setTouched] = useState(false); // Track if the field has been interacted with
  const isFieldInvalid = convertBookForm && touched && !selectedPitched;
  const companyName = searchParams.get('companyName');
  const name = searchParams.get('name');
  const screen = searchParams.get('screen');
  const createNewProposal = searchParams.get('createNewProposal');
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);
  const [isBollen, seTisBollen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [submittedData, setSubmittedData] = useState<LeadsDto | null>(null);
  const [phoneCode, setPhonecode] = useState({ isoCode: '', code: '' });
  const nameOfScreen =
    searchParams.get('name') === 'converToProposals'
      ? 'converToLeads'
      : 'proposals';
  const [alternatephoneCode, setAltPhonecode] = useState({
    isoCode: '',
    code: '',
  });
  const [events, setEvents] = useState<EventReqDtos[]>([]);
  const [isEventAdded, setIsEventAdded] = useState(false);
  const [centerEvents, setCenterEvents] = useState<HospitalCenterReqDto[]>([]);
  const [expanded, setExpanded] = useState<string | false>(false);
  const [centerExpanded, setCenterExpanded] = useState<string | false>(false);
  const { setLoading } = useLoader();
  const [continents, setContinent] = useState<MtContinentDto[]>([]);
  const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
  const [selectedFile, setSelectedFile] = useState<string[]>([]);
  const [file, setFile] = useState<(File | null)[]>([]);
  const fileInputRef = useRef<HTMLInputElement[]>([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  // const endDateRef = useRef<HTMLInputElement>(null);
  const [selectedType, setType] = useState('COMPANY');
  const formatFileSize = (size: number): string => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    return parseFloat((size / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
  };
  const clearFile = (index: number) => {
    // Implement your logic to clear the file
    setFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles[index] = null;
      return updatedFiles;
    });
  };
  const usersScreen = () => {
    if (createNewProposal === 'booked') {
      navigate('/portals/bookings/viewBooking');
    } else if (createNewProposal === 'confirmedBook') {
      navigate('/portals/bookings/confirmedBooking');
    } else if (createNewProposal === 'expiredService') {
      navigate('/portals/bookings/expiredService');
    } else if (name === 'converToProposals') {
      navigate('/portals/leads/viewUser');
    } else if (companyName) {
      navigate('/portals/bookings/viewBooking');
    } else {
      navigate('/portals/proposals/viewProposal');
    }
  };
  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = event.target.files?.[0];
    const allowedTypes = ['image/png', 'image/jpeg'];
    const maxSizeInMB = 3;

    if (file) {
      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        alert('Please select a valid image (PNG or JPG).');
        return;
      }

      // Validate file size
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`File size should not exceed ${maxSizeInMB} MB.`);
        return;
      }

      // Create a file URL
      const fileUrl = URL.createObjectURL(file);

      // Update the file array
      setFile((prevFiles) => {
        const updatedFiles = [...prevFiles];
        updatedFiles[index] = file; // Assign the file at the given index
        return updatedFiles;
      });

      // Update the preview URL array
      setSelectedFile((prevUrls) => {
        const updatedUrls = [...prevUrls];
        updatedUrls[index] = fileUrl; // Assign the URL at the given index
        return updatedUrls;
      });
    }
  };
  const location = useLocation();
  const reUploadFile = (index: number) => {
    if (fileInputRef.current[index]) {
      fileInputRef.current[index].click();
    }
  };
  const [page, setPage] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const [totalPages, setTotalPages] = useState(false);
  const handleInputChange = (inputValue: string) => {
    setSearchInput(inputValue);
    setPage(0); // Reset page
    assignTo(inputValue); // Fetch filtered data
    // const selectedPitchedId = e.target.value;
    // setSelectedPitched(selectedPitchedId);
  };
  const handleMenuScrollToBottom = () => {
    if (!totalPages) {
      setPage((prevPage) => prevPage + 1);
      assignTo(searchInput);
    }
  };
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSelectedDate(value);
    setValue('bookingDate', value, { shouldValidate: true }); // Force validation after setting value
    if (value) {
      clearErrors('bookingDate'); // Clear errors if a date is selected
    }
  };
  const isAnyServiceSelected = () => {
    // Check if any of the relevant checkboxes are checked
    return (
      formData.isContentMarketing ||
      formData.isHospitalProfiling ||
      formData.isCompanyProfiling ||
      // formData.isEventProfiling ||
      formData.isEventListing ||
      formData.isCenterListing ||
      formData.isBannerAds ||
      formData.isEmailMarketing ||
      formData.isNewsLetterAds ||
      formData.isContentMarketing ||
      formData.isPrintAd
    );
  };
  const mtCurrencyDtoData = async () => {
    setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.mtCurrency);
      console.log(response);
      setMtCurrency(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const mtStateData = async () => {
    try {
      const respose = await getService(API_ENDPOINTS.matState);
      mtState(respose.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
    }
  };
  const currencyCode = (e: any) => {
    const selectedCurrency = e.target.value;
    setSelectedCurrency(selectedCurrency);
  };
  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: keyof typeof formData
  ) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: e.target.checked, // Update the value based on the checkbox state
    }));
  };
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setStartDate(selectedDate); // Update start date
    const nextDay = new Date(selectedDate);
    nextDay.setDate(nextDay.getDate() + 1); // Set next day after the selected start date
    setEndDate(nextDay.toISOString().split('T')[0]); // Update end date state to be the next day
  };
  const handleStartDateChange1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setStartDate(selectedDate); // Update start date
    const nextDay = new Date(selectedDate);
    nextDay.setDate(nextDay.getDate() + 1); // Set next day after the selected start date
    setEndDate1(nextDay.toISOString().split('T')[0]); // Update end date state to be the next day
  };
  const handleStartDateChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setStartDate(selectedDate); // Update start date
    const nextDay = new Date(selectedDate);
    nextDay.setDate(nextDay.getDate() + 1); // Set next day after the selected start date
    setEndDate2(nextDay.toISOString().split('T')[0]); // Update end date state to be the next day
  };
  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const handleCenterChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setCenterExpanded(isExpanded ? panel : false);
    };
  const viewUsers = () => {
    setIsShow(false);
    // navigate(-1);
    if (
      (userId && companyName) ||
      (userId && name === 'converToProposals') ||
      (userId && convertBookForm)
    ) {
      navigate('/portals/bookings/viewBooking');
    }
    if (
      (selectedTypes === 'INVITE' || selectedTypes === 'TRIAL') &&
      userInfo?.roles === 'SALES_ADMIN'
    ) {
      navigate('/portals/vendors/activeVendor');
    } else if (
      (userId && convertBookForm === 'EditconvertToBookingForm') ||
      (userId && convertBookForm)
    ) {
      navigate('/portals/bookings/viewBooking');
    } else if (screen === 'viewBooked') {
      navigate('/portals/bookings/viewBooking');
    } else {
      navigate('/portals/proposals/viewProposal');
    }
  };
  const closePopup = () => {
    setIsShow(false);
    setTimeout(() => {
      resetFormData();

      navigate('/portals/proposals/addProposal');
      window.location.reload();
    }, 500);
  };
  const handleCountryChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    fieldType: 'country' | 'eventCountry'
  ) => {
    const selectedCountryId = e.target.value;
    if (selectedCountryId === '1') {
      setSelectedCurrency('2');
    }
    console.log(selectedCountryId);
    // Identify which field triggered the change and update the correct state
    if (fieldType === 'country') {
      setSelectedCountry(selectedCountryId);
    } else if (fieldType === 'eventCountry') {
      setSelectedContry(selectedCountryId);
    }

    const selectedCountry = mtContryData.find(
      (country: any) => country.id == selectedCountryId
    );
    if (selectedCountry) {
      setPhonecode((prev) => {
        const updatedPhoneCode = {
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        };
        return updatedPhoneCode;
      });
      setAltPhonecode((prev) => ({
        isoCode: selectedCountry.isoCode,
        code: selectedCountry.code,
      }));
    }
    setValue('mtCountryDto', selectedCountryId); // Update React Hook Form value
    trigger('mtCountryDto');
  };

  const handlePitchedChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedPitchedId = e.target.value;
    setSelectedPitched(selectedPitchedId);
  };
  const handleContinentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedContinentId = e.target.value;
    setSelectedContinent(selectedContinentId); // ✅ Update state to reflect in dropdown

    console.log('Selected Continent ID:', selectedContinentId);

    // const selectedContinentObj = continents.find(
    //   (continent) => String(continent.id) === selectedContinentId
    // );

    if (selectedContinentId) {
      setValue('mtContinentDto', selectedContinentId as any);
    } else {
      // setValue("mtContinentDto", null);
    }

    trigger('mtContinentDto');
  };
  const altPhoneNuberChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIsoCode = e.target.value;
    const selectedCountry = mtContryData.find(
      (country: any) => country.isoCode === selectedIsoCode
    );
    if (selectedCountry) {
      setAltPhonecode({
        isoCode: selectedCountry.isoCode,
        code: selectedCountry.code,
      });
      setValue('directNo', '');
    }
  };
  const phoneNuberChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIsoCode = e.target.value;
    const selectedCountry = mtContryData.find(
      (country: any) => country.isoCode === selectedIsoCode
    );

    if (selectedCountry) {
      setPhonecode({
        isoCode: selectedCountry.isoCode,
        code: selectedCountry.code,
      });
      setValue('contactNo', '');
    }
  };
  const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setFile([]);
    setType(selectedValue);
    if (selectedValue) {
      clearErrors('type');
    }
    if (selectedValue === 'EVENT_ORGANIZER') {
      const newEventId = events.length + 1;
      setEvents([
        ...events,
        {
          id: newEventId,
          name: `Event ${newEventId}`,
          startDate: '',
          endDate: '',
          contactPersonName: '',
          contactPersonEmail: '',
          phoneNo: '',
          mtCountryDto: {
            id: null,
            name: '',
            code: '',
            isoCode: '',
          }, // Default mtCountryDto object
          venue: '',
          link: '',
          type: '',
          imageDto: {
            name: '',
            base64Str: '',
            type: '',
            documentUrl: '',
          },
        },
      ]);
    } else {
      setEvents([]);
    }

    if (selectedValue === 'HOSPITAL') {
      // setCenterEvents([{ id: 1, name: 'Center 1' }]); // Initialize with one event or fetch from API
      setCenterEvents([
        ...centerEvents,
        {
          id: 1,
          name: `Center 1`,
          branchAddress: '',
          specialization: '',
          size: '',
          type: '',
          centerSize: '',
          imageDto: {
            name: '',
            base64Str: '',
            type: '',
            documentUrl: '',
          },
        },
      ]);
    } else {
      setCenterEvents([]);
    }
    setValue('type', selectedValue);
  };
  const handleTypeChanges = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    setValue('types', selectedValue);
    trigger('types');
    setSelectedType(selectedValue);
  };

  const handleAddEvent = () => {
    if (isEventAdded) return;
    const newEventId = events.length + 1;
    setEvents([
      ...events,
      {
        id: newEventId,
        name: `Event ${newEventId}`,
        startDate: '',
        endDate: '',
        contactPersonName: '',
        contactPersonEmail: '',
        phoneNo: '',
        mtCountryDto: {
          id: null,
          name: '',
          code: '',
          isoCode: '',
        },
        venue: '',
        link: '',
        type: '',
        imageDto: {
          name: '',
          base64Str: '',
          type: '',
          documentUrl: '',
        },
      },
    ]);
    setExpanded(`panel${newEventId}`);
  };
  const handleCenterAddEvent = () => {
    const newEventId = centerEvents.length + 1;
    setCenterEvents([
      ...centerEvents,
      {
        id: newEventId,
        name: `Center ${newEventId}`,
        branchAddress: '',
        specialization: '',
        size: '',
        type: '',
        centerSize: '',
        imageDto: {
          name: '',
          base64Str: '',
          type: '',
          documentUrl: '',
        },
      },
    ]);
    setCenterExpanded(`panel${newEventId}`);
    setIsEventAdded(true);
  };

  const onSubmit = async (data: LeadsDto) => {
    console.log('Form data before transformation:', data);
    setSubmittedData(data);
    handleOpenPopup();
  };
  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);
  const handleConfirm = async () => {
    handleClosePopup();
    setLoading(true);
    try {
      let response;
      let url: any;
      const convertFileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result as string);
          reader.onerror = (error) => reject(error);
        });
      };
      const formattedAltPhoneNumber = submittedData?.directNo?.startsWith(
        alternatephoneCode?.code
      )
        ? submittedData?.directNo // If it already starts with country code, don't add again
        : alternatephoneCode?.code +
          (alternatephoneCode?.code ? ' ' : '') +
          submittedData?.directNo;
          
      const formattedPhoneNumber = submittedData?.contactNo?.startsWith(
        phoneCode?.code
      )
        ? submittedData?.contactNo // If it already starts with country code, don't add again
        : phoneCode?.code +
          (phoneCode?.code ? ' ' : '') +
          submittedData?.contactNo;
      let payload: any = {
        gstNo: submittedData?.gstNo,
        leadType: submittedData?.type,
        source: submittedData?.source === '' ? null : submittedData?.source,
        contactNo: submittedData?.contactNo ? formattedPhoneNumber : '',
        directNo: submittedData?.directNo ? formattedAltPhoneNumber : '',
        email: submittedData?.email,
        contactPersonRole: submittedData?.contactPersonRole,
        companyName: submittedData?.companyName,
        contactPersonName: submittedData?.contactPersonName,
        callBackDate: submittedData?.callBackDate
          ? moment(submittedData?.callBackDate, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        streetAddress: submittedData?.streetAddress,
        website: submittedData?.website,
        street: submittedData?.street,
        apartment: submittedData?.apartment,

        city: submittedData?.city,
        postalCode: submittedData?.postalCode,
        sourceUrl: submittedData?.sourceUrl,
        feedback: submittedData?.feedback,
        pitchedById: selectedPitched
          ? selectedPitched
          : parseInt(submittedData?.pitchedById, 10)
          ? parseInt(submittedData?.pitchedById, 10)
          : selectedPitched,
        mtCountryDto: {
          id: parseInt(submittedData?.mtCountryDto as unknown as string, 10)
            ? parseInt(submittedData?.mtCountryDto as unknown as string, 10)
            : selectedCountry,
        },
        mtContinentDto: {
          id: parseInt(submittedData?.mtContinentDto as unknown as string, 10)
            ? parseInt(submittedData?.mtContinentDto as unknown as string, 10)
            : selectedContinent,
        },
        type: submittedData?.types,
        mtCurrencyDto: submittedData?.mtCurrencyDto?.id
          ? {
              id: submittedData.mtCurrencyDto.id,
            }
          : undefined,
        value: parseFloat(submittedData?.value as unknown as string),
        // value: submittedData?.value,
        bookingDate: submittedData?.bookingDate
          ? moment(submittedData?.bookingDate, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        isHospitalProfiling: formData?.isHospitalProfilingExist
          ? false
          : formData?.isHospitalProfiling,
        isCenterListing: formData?.isCenterListing,

        isEventListing: formData?.isEventListing,
        isBannerAds: formData?.isBannerAds,
        bannerAdFrom: submittedData?.bannerAdFrom
          ? moment(submittedData?.bannerAdFrom, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',

        bannerAdTo: submittedData?.bannerAdTo
          ? moment(submittedData?.bannerAdTo, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '',
        noOfBanners: submittedData?.noOfBanners,
        isEmailMarketing: formData?.isEmailMarketing,
        noOfRecipients: submittedData?.noOfRecipients,
        noOfEdms: submittedData?.noOfEdms,
        isNewsLetterAds: formData?.isNewsLetterAds,
        newsLetterAdFrom: submittedData?.newsLetterAdFrom
          ? moment(submittedData?.newsLetterAdFrom, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        newsLetterAdTo: submittedData?.newsLetterAdTo
          ? moment(submittedData?.newsLetterAdTo, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        noOfNewsBanners: submittedData?.noOfNewsBanners,
        isContentMarketing: formData?.isContentMarketing,
        isPrintAd: formData?.isPrintAd,
        noOfPosts: submittedData?.noOfPosts,
        noOfEvents: submittedData?.noOfEvents,
        eventListingTo: submittedData?.eventListingTo
          ? moment(submittedData?.eventListingTo, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        eventListingFrom: submittedData?.eventListingFrom
          ? moment(submittedData?.eventListingFrom, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        printAdd: submittedData?.printAdd,
        contntMarktAdFrom: submittedData?.contntMarktAdFrom
          ? moment(submittedData?.contntMarktAdFrom, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        contntMarktAdTo: submittedData?.contntMarktAdTo
          ? moment(submittedData?.contntMarktAdTo, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            )
          : '',
        printAdType: submittedData?.printAdType,
        noOfPrintAds: submittedData?.noOfPrintAds,
        additionalService: submittedData?.additionalService,
        isCompanyProfiling: formData?.isCompanyProfilingExist
          ? false
          : formData?.isCompanyProfiling,
        // isEventProfiling: formData?.isEventProfiling,
        eventIdList: submittedData?.eventIdList,
      };
      if (selectedCountry == '1') {
        payload.mtStateDto = submittedData?.state
          ? {
              id: submittedData?.state,
            }
          : null;
      } else {
        payload.state = submittedData?.state;
      }

      if (name === 'converToProposals') {
        const leadIdList = submittedData?.id ? [submittedData.id] : [];
        let convertLeadsUrl;
        convertLeadsUrl = API_ENDPOINTS.convertProposal;
        let body = {
          leadId: submittedData?.id,

          ...payload,
        };
        if (convertLeadsUrl) {
          response = await postService(convertLeadsUrl, body);
        }
      } else if (convertBookForm === 'convertToBookingForm') {
        let updatePayload = {
          id: userId ? parseInt(userId, 10) : undefined, // Handle null case
          ...payload,
        };
        response = await postService(
          API_ENDPOINTS.convertBooking,
          updatePayload
        );
      } else if (userId) {
        let updatePayload = {
          id: parseInt(userId, 10),

          ...payload,
        };
        // payload.id = parseInt(userId, 10);
        url = API_ENDPOINTS.updateProposal;

        response = await postService(url, updatePayload);
      } else if (leadId) {
        // payload.id=submittedData?.id
        payload.leadId = submittedData?.leadId;
        url = API_ENDPOINTS.saveProposal;
        response = await postService(url, payload);
      } else {
        url = API_ENDPOINTS.saveProposal;
        response = await postService(url, payload);
      }

      if (response.statusCode === 200) {
        setIsShow(true);
        if (nameOfScreen === 'converToLeads') {
          if (selectedTypes === 'INVITE' || selectedTypes === 'TRIAL') {
            setIsShow(true);
          } else {
            showToast(
              'Lead Successfully Converted!',
              'success',
              'Your lead has been successfully converted into a proposal.'
            );
            navigate('/portals/proposals/viewProposal');
          }
        }
      }
    } catch (error: any) {
      showToast(error?.response?.data?.message, 'error', '');
      console.error('Error saving user:', error);
    } finally {
      setLoading(false);
    }
  };
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [assignToSubUsers, setAssignTo] = useState<any[]>([]);

  useEffect(() => {
    const loadInitialData = async () => {
      await mtContinetData();
      await mtCountryDtoData();
      mtCurrencyDtoData();
      mtStateData();
      setMtCountryDataLoaded(true);
    };

    loadInitialData();
    if ((userId && mtCountryDataLoaded) || leadId) {
      fetchVehicles();
    } else if (!userId) {
      // setSubmittedData(emptyData);
      const selectedCountry = mtContryData.find(
        (country: any) => country.id == '1'
      );
      setPhonecode({
        isoCode: selectedCountry?.isoCode ? selectedCountry?.isoCode : '1',
        code: selectedCountry?.code ? selectedCountry?.code : '1',
      });
      setAltPhonecode({
        isoCode: selectedCountry?.isoCode ? selectedCountry?.isoCode : '1',
        code: selectedCountry?.code ? selectedCountry?.code : '1',
      });
      setValue('phoneisoCode', '1');
      setValue('alternateIsoCode', '1');
      // resetFormData(); // Reset form when no userId is present
    }
  }, [userId, mtCountryDataLoaded, location]);

  const resetFormData = () => {
    console.log('Resetting form data...');
    const emptyData = {
      uuid: '',
      id: 0,
      type: '',
      source: '',
      companyName: '',
      contactPersonName: '',
      email: '',
      callBackDate: '',
      contactNo: '',
      address: '',
      website: '',
      sourceUrl: '',
      feedback: '',
      mtContinentDto: {
        id: 0,
        continent: '',
        name: '',
      },
      directNo: '',
      startDate: '',
      endDate: '',
      leadRespDto: {
        address: '',
        companyName: '',
        contactPersonName: '',
        contactPerson: '',
        directNo: '',
        contactNo: 0,
        contactPersonRole: '',
        website: '',
        sourceUrl: '',
        mtContinentDto: {
          id: 0,
          continent: '',
          name: '',
        },
        callBackDate: '',
        mtCountryDto: {
          id: 0,
          name: '',
          code: '',
          isoCode: '',
        },
        feedback: '',
        pitchedBy: '',
        eventReqDtos: [],
        eventRespDtos: [],
        centerRespDtos: [],
        centerReqDtos: [],
      },
      eventReqDtos: [],
      eventRespDtos: [],
      centerRespDtos: [],
      centerReqDtos: [],
      alternateIsoCode: '',
      phoneisoCode: '',
      addedBy: '',
      addedDate: '',
      status: '',
      street: '',
      apartment: '',
    };
    reset(emptyData);
  };
  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let url: any;
      if (leadId) {
        url = API_ENDPOINTS.getLeadProposal + '?id=' + leadId;
      } else if (!name) {
        url = API_ENDPOINTS.getLeadProposal + '?id=' + userId;
      } else {
        if (userInfo.roles === 'SALES_MANAGER') {
          url = API_ENDPOINTS.salesManagerLeadsApi + '?leadId=' + userId;
        } else if (userInfo.roles === 'SALES_ADMIN') {
          url = API_ENDPOINTS.salesGetLeadsApi + '?leadId=' + userId;
        } else if (userInfo.roles === 'SALES_TEAM_LEAD') {
          url = API_ENDPOINTS.salesTlLeadsApi + '?leadId=' + userId;
        } else if (userInfo.roles === 'SALES_EXECUTIVE') {
          url = API_ENDPOINTS.salesExicuteLeadsApi + '?leadId=' + userId;
        }
      }
      const response = await getService(url);
      if(!response.data?.mtCountryDto?.id && name === 'converToProposals'){
        if (mtContryData.length > 0) {
          const indiaOption = mtContryData.find(country => 
            country.name?.toLowerCase() === 'india'
          );
          if (indiaOption) {
            setSelectedCountry(indiaOption.id?.toString() as any);
          }
          }
      }else{
        setSelectedCountry(response.data?.mtCountryDto?.id);
      };
      
      setSelectedContinent(response.data?.mtContinentDto?.id);
      setSelectedPitched(response.data?.pitchedById);
      setSelectedDate(
        response.data.bookingDate
          ? moment(response.data.bookingDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : ''
      );
      setFormData({
        ...formData,
        isHospitalProfiling: !!response.data.isHospitalProfiling,
        isCenterListing: !!response.data.isCenterListing,
        isBannerAds: !!response.data.isBannerAds,
        isEmailMarketing: !!response.data.isEmailMarketing,
        isNewsLetterAds: !!response.data.isNewsLetterAds,
        isContentMarketing: !!response.data.isContentMarketing,
        // isEventProfiling: !!response.data.isEventProfiling,
        isCompanyProfiling: !!response.data.isCompanyProfiling,
        isEventListing: !!response.data.isEventListing,
        isPrintAd: !!response.data.isPrintAd,
        isHospitalProfilingExist: !!response.data.isHospitalProfilingExist,
        isCompanyProfilingExist: !!response.data.isCompanyProfilingExist,
      });
      if ((userId && companyName) || (userId && name === 'converToProposals')) {
        setEvents(response.data?.eventRespDtos);
        setCenterEvents(response.data?.centerRespDtos);
        let trimmedPhone = response.data?.contactNo
          ? response.data.contactNo.split(' ')
          : '';
        let altTrimmedPhone = response.data?.directNo
          ? response.data.directNo.split(' ')
          : '';
        const selectedPhoneCountry = mtContryData.find(
          (country: any) => country.code === trimmedPhone[0]
        );
        const selectedAltCountry = mtContryData.find(
          (country: any) => country.code === altTrimmedPhone[0]
        );
        reset({
          ...response.data,
          callBackDate: response?.data?.callBackDate
            ? moment(response?.data?.callBackDate, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '', // Default to an empty string if callBackDate is not available
          pitchedBy: response.data.pitchedById,
          gstNo: response.data.gstNo,
          //     type:response?.data?.leadType,
          // types:response.data?.type,
          // contactNo:trimmedPhone[2] ? trimmedPhone[2] : trimmedPhone[1] ? trimmedPhone[1] : response.data?.contactNo,
          //             directNo:altTrimmedPhone[2] ? altTrimmedPhone[2] : altTrimmedPhone[1] ? altTrimmedPhone[1] : response.data?.directNo,
          type: response?.data?.leadType
            ? response?.data?.leadType
            : response?.data?.type,
          types: response?.data?.leadType ? response.data?.type : '',
          state: response.data?.mtStateDto?.id
            ? response.data?.mtStateDto?.id
            : response?.data?.state,
          additionalService: response.data.additionalService,
          mtCurrencyDto: response.data?.mtCurrencyDto?.id,
          contactNo: trimmedPhone[2]
            ? trimmedPhone[2]
            : trimmedPhone[1]
            ? trimmedPhone[1]
            : response.data?.contactNo,
          directNo: altTrimmedPhone[2]
            ? altTrimmedPhone[2]
            : altTrimmedPhone[1]
            ? altTrimmedPhone[1]
            : response.data?.directNo,
          bannerAdFrom: response.data.bannerAdFrom
            ? moment(response.data.bannerAdFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          bannerAdTo: response.data.bannerAdTo
            ? moment(response.data.bannerAdTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          bookingDate: response.data.bookingDate
            ? moment(response.data.bookingDate, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          contntMarktAdFrom: response.data.contntMarktAdFrom
            ? moment(response.data.contntMarktAdFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          contntMarktAdTo: response.data.contntMarktAdTo
            ? moment(response.data.contntMarktAdTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          eventListingFrom: response.data.eventListingFrom
            ? moment(response.data.eventListingFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          eventListingTo: response.data.eventListingTo
            ? moment(response.data.eventListingTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          newsLetterAdFrom: response.data.newsLetterAdFrom
            ? moment(response.data.newsLetterAdFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          newsLetterAdTo: response.data.newsLetterAdTo
            ? moment(response.data.newsLetterAdTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          id: response.data.id,
          isHospitalProfiling: !!response.data.isHospitalProfiling,
          isCenterListing: !!response.data.isCenterListing,
          isBannerAds: !!response.data.isBannerAds,
          isEmailMarketing: !!response.data.isEmailMarketing,
          isNewsLetterAds: !!response.data.isNewsLetterAds,
          isContentMarketing: !!response.data.isContentMarketing,
          // isEventProfiling: !!response.data.isEventProfiling,
          isCompanyProfiling: !!response.data.isCompanyProfiling,
          isEventListing: !!response.data.isEventListing,
          isPrintAd: !!response.data.isPrintAd,
          noOfBanners: response.data.noOfBanners,
          noOfEdms: response.data.noOfEdms,
          noOfNewsBanners: response.data.noOfNewsBanners,
          noOfPosts: response.data.noOfPosts,
          noOfEvents: response.data.noOfEvents,
          noOfPrintAds: response.data.noOfPrintAds,
          noOfRecipients: response.data.noOfRecipients,
          printAdType: response.data.printAdType,
          value: response.data.value,
          printAdd: response.data.printAdd,
        });
      } else {
        let trimmedPhone = response.data?.contactNo
          ? response.data.contactNo.split(' ')
          : '';
        let altTrimmedPhone = response.data?.directNo
          ? response.data.directNo.split(' ')
          : '';
        const selectedPhoneCountry = mtContryData.find(
          (country: any) => country.code === trimmedPhone[0]
        );
        const selectedAltCountry = mtContryData.find(
          (country: any) => country.code === altTrimmedPhone[0]
        );
        reset({
          ...response.data, // Resetting other data from the response
          callBackDate: response?.data?.callBackDate
            ? moment(response?.data?.callBackDate, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          gstNo: response.data.gstNo,
          state: response.data?.mtStateDto?.id
            ? response.data?.mtStateDto?.id
            : response?.data?.state,
          pitchedBy: response.data?.pitchedById,
          // type:response?.data?.leadType,
          // types:response.data?.type,
          type: response?.data?.leadType
            ? response?.data?.leadType
            : response?.data?.type,
          types: response?.data?.leadType ? response.data?.type : '',
          additionalService: response.data.additionalService,
          mtCurrencyDto: response.data?.mtCurrencyDto?.id,
          contactNo: trimmedPhone[2]
            ? trimmedPhone[2]
            : trimmedPhone[1]
            ? trimmedPhone[1]
            : response.data?.contactNo,
          directNo: altTrimmedPhone[2]
            ? altTrimmedPhone[2]
            : altTrimmedPhone[1]
            ? altTrimmedPhone[1]
            : response.data?.directNo,
          bannerAdFrom: response.data.bannerAdFrom
            ? moment(response.data.bannerAdFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          bannerAdTo: response.data.bannerAdTo
            ? moment(response.data.bannerAdTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          bookingDate: response.data.bookingDate
            ? moment(response.data.bookingDate, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          contntMarktAdFrom: response.data.contntMarktAdFrom
            ? moment(response.data.contntMarktAdFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          contntMarktAdTo: response.data.contntMarktAdTo
            ? moment(response.data.contntMarktAdTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          eventListingFrom: response.data.eventListingFrom
            ? moment(response.data.eventListingFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          eventListingTo: response.data.eventListingTo
            ? moment(response.data.eventListingTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          newsLetterAdFrom: response.data.newsLetterAdFrom
            ? moment(response.data.newsLetterAdFrom, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          newsLetterAdTo: response.data.newsLetterAdTo
            ? moment(response.data.newsLetterAdTo, 'DD/MM/YYYY').format(
                'YYYY-MM-DD'
              )
            : '',
          id: response.data.id,
          isHospitalProfiling: !!response.data.isHospitalProfiling,
          isCenterListing: !!response.data.isCenterListing,
          isBannerAds: !!response.data.isBannerAds,
          isEmailMarketing: !!response.data.isEmailMarketing,
          isNewsLetterAds: !!response.data.isNewsLetterAds,
          isContentMarketing: !!response.data.isContentMarketing,
          // isEventProfiling: !!response.data.isEventProfiling,
          isCompanyProfiling: !!response.data.isCompanyProfiling,
          isEventListing: !!response.data.isEventListing,
          isPrintAd: !!response.data.isPrintAd,
          noOfBanners: response.data.noOfBanners,
          noOfEdms: response.data.noOfEdms,
          noOfNewsBanners: response.data.noOfNewsBanners,
          noOfPosts: response.data.noOfPosts,
          noOfEvents: response.data.noOfEvents,
          noOfPrintAds: response.data.noOfPrintAds,
          noOfRecipients: response.data.noOfRecipients,
          printAdType: response.data.printAdType,
          value: response.data.value,
          printAdd: response.data.printAdd,
        });
      }

      // reset({
      //   ...response.data,
      //   type:response?.data?.leadType ? response?.data?.leadType : response?.data?.type,
      //   types:response?.data?.leadType ? response.data?.type : '',
      //   contactNo:trimmedPhone[2],
      //   directNo:altTrimmedPhone[2]
      // });
      let trimmedPhone = response.data?.contactNo
        ? response.data.contactNo.split(' ')
        : '';
      let altTrimmedPhone = response.data?.directNo
        ? response.data.directNo.split(' ')
        : '';
      const selectedPhoneCountry = mtContryData.find(
        (country: any) => country.code === trimmedPhone[0]
      );
      const selectedAltCountry = mtContryData.find(
        (country: any) => country.code === altTrimmedPhone[0]
      );
      if (selectedPhoneCountry) {
        setPhonecode({
          isoCode: selectedPhoneCountry.isoCode,
          code: selectedPhoneCountry.code,
        });
      } else {
        let selectedCountry: any;
        if (response.data?.mtCountryDto?.id) {
          selectedCountry = mtContryData.find(
            (country: any) => country.id == response.data?.mtCountryDto?.id
          );
          if (selectedCountry) {
            setAltPhonecode((prev) => ({
              isoCode: selectedCountry.isoCode,
              code: selectedCountry.code,
            }));
          }
        } else {
          selectedCountry = mtContryData.find(
            (country: any) => country.id == '1'
          );
          if (selectedCountry) {
            setAltPhonecode((prev) => ({
              isoCode: selectedCountry.isoCode,
              code: selectedCountry.code,
            }));
          }
        }
      }

      setSubmittedData(response.data);
      setType(
        response.data.leadType ? response.data.leadType : response.data.type
      );
      setSelectedType(response.data.leadType ? response.data.type : 'PAID');
      if (selectedAltCountry) {
        setAltPhonecode({
          isoCode: selectedAltCountry.isoCode,
          code: selectedAltCountry.code,
        });
      } else {
        let selectedCountry: any;
        selectedCountry = mtContryData.find(
          (country: any) => country.id == response.data?.mtCountryDto?.id
        );
        if (selectedCountry) {
          setPhonecode((prev) => {
            const updatedPhoneCode = {
              isoCode: selectedCountry.isoCode,
              code: selectedCountry.code,
            };
            return updatedPhoneCode;
          });
        } else {
          selectedCountry = mtContryData.find(
            (country: any) => country.id == '1'
          );
          if (selectedCountry) {
            setPhonecode((prev) => ({
              isoCode: selectedCountry.isoCode,
              code: selectedCountry.code,
            }));
          }
        }
      }
      if(response.data.mtCurrencyDto){
        setValue('mtCurrencyDto', response.data.mtCurrencyDto);
      }
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const assignTo = async (input: string) => {
    setLoading(true);
    try {
      let url: string | undefined;
      let body: any = {
        isAllUsers: true,
        isDropDown: true,
        page: page,
        search: input,
      };

      // Set URL based on userInfo.roles
      if (userInfo.roles === 'SALES_ADMIN') {
        url = API_ENDPOINTS.salesUserDetails;
      } else if (userInfo.roles === 'SALES_TEAM_LEAD') {
        url = API_ENDPOINTS.tlUserDetails;
      } else if (userInfo.roles === 'SALES_EXECUTIVE') {
        url = API_ENDPOINTS.executiveUserDetails;
      } else if (userInfo.roles === 'SALES_MANAGER') {
        url = API_ENDPOINTS.smUserDetails;
      }

      if (!url) {
        console.error('No API URL found for this role');
        setLoading(false);
        return;
      }

      const response = await postService(url, body);
      if (response.data?.content) {
        // Merge existing users with the new ones, avoiding duplicates
        const uniqueUsers = getUniqueUsers([
          ...assignToSubUsers,
          ...response.data.content,
        ]);
        setAssignTo(uniqueUsers); // Update state with filtered unique users
        setTotalPages(response.data.last); // Set total pages from response
      }
      setTotalPages(response.data.last);
      if (response.data) {
        seTisBollen(!response.data.content.length);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setLoading(false);
    }
  };
  const getUniqueUsers = (users: any[]) => {
    const seen = new Set();
    return users.filter((user) => {
      if (seen.has(user.appUserId)) return false;
      seen.add(user.appUserId);
      return true;
    });
  };
  const mtCountryDtoData = async () => {
    // setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.countryData);
      setMtCountry(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const mtContinetData = async () => {
    // setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.mtCotinent);
      setContinent(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  useEffect(() => {
    assignTo(searchInput);

    // Call the function to fetch user details
  }, [userInfo.roles, searchInput]);

  const proposals = () => {
    if (createNewProposal === 'booked') {
      navigate('/portals/bookings/viewBooking');
    } else if (createNewProposal === 'confirmedBook') {
      navigate('/portals/bookings/confirmedBooking');
    } else if (createNewProposal === 'expiredService') {
      navigate('/portals/bookings/expiredService');
    } else if (name === 'converToProposals') {
      navigate('/portals/leads/viewUser');
    } else if (companyName) {
      navigate('/portals/bookings/viewBooking');
    } else {
      navigate('/portals/proposals/viewProposal');
    }
  };
  const path = location.pathname;
  const handleDateClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault(); // Prevent default click action if needed
    e.currentTarget.showPicker(); // Re-focus to trigger the date picker again
  };

  const handleSelectChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    if (submittedData) {
      // Create a shallow copy of submittedData
      const updatedData = { ...submittedData };

      // Ensure centerRespDtos array exists before updating the value
      if (updatedData.centerRespDtos && updatedData.centerRespDtos[index]) {
        updatedData.centerRespDtos[index].centerSize = e.target.value;

        // Update the state with the new value
        setSubmittedData(updatedData);
      }
    }
  };

  return (
    <div className='h-full py-2 w-full'>
      <div className='flex items-center cursor-pointer mb-4'>
        <h2
          className='mr-2 text-gray-700 font-semibold text-sm'
          onClick={proposals}
        >
          {createNewProposal === 'booked'
            ? 'Booked'
            : createNewProposal === 'confirmedBook'
            ? 'Confirmed'
            : createNewProposal === 'expiredService'
            ? 'Expired'
            : name === 'converToProposals'
            ? 'Leads'
            : companyName ||
              path === '/portals/bookings/viewBooking/addProposal'
            ? 'Booked'
            : 'Proposals'}
        </h2>{' '}
        {userId && convertBookForm && (
          <>
            <img src='/images/arrowIcons.svg' className='mr-2' />{' '}
            <span className='text-gray-400 font-semibold text-sm mr-2'>
              {submittedData?.companyName}
            </span>
          </>
        )}
        <img src='/images/arrowIcons.svg' className='mr-2' />{' '}
        <span className='text-gray-400 font-semibold text-sm'>
          {userId && name == 'converToProposals'
            ? 'Convert to Proposal'
            : userId && convertBookForm === 'EditconvertToBookingForm'
            ? 'Edit Book Proposal & Send for Signature'
            : userId && convertBookForm
            ? 'Book Proposal & Send for Signature'
            : userId && name !== 'converToProposals'
            ? companyName
              ? `Edit ${companyName}`
              : 'Edit Proposal'
            : 'Add Proposal'}
        </span>
      </div>

      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission on Enter for all form fields
          }
        }}
      >
        <div className='bg-white'>
          <div className='w-full px-6  pt-6 scroolCls h-[70vh] overflow-y-scroll pb-10'>
            <div className='pb-5 '>
              <p className='text-primary-color font-semibold text-2xl border-b border-gray-200 pb-4'>
                {userId && name == 'converToProposals'
                  ? 'Convert to Proposal'
                  : userId && convertBookForm === 'EditconvertToBookingForm'
                  ? 'Edit Convert to Order Form'
                  : userId && convertBookForm
                  ? 'Finalize Booking Proposal'
                  : userId && name !== 'converToProposals'
                  ? companyName
                    ? `Edit ${companyName}`
                    : 'Edit Proposal'
                  : 'Add Proposal'}
              </p>
            </div>
            <div className='w-full sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4'>
              <div className='grid grid-cols-2 gap-6'>
                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Lead Type <span className='font-[400]'> (Required)</span>
                  </label>
                  <div className='relative'>
                    <select
                      {...register('type', {
                        required: 'Lead type is required',
                      })}
                      disabled={Boolean(userId) || Boolean(leadId)}
                      // disabed={!!userId}
                      onChange={handleTypeChange}
                      className={`form-control p-2 rounded mt-1 w-full ${
                        errors.type
                          ? 'border-[#B91C1C] border-2'
                          : 'border-gray-300 border'
                      }`}
                    >
                      <option value=''>Select Lead type</option>
                      <option value='COMPANY'>Company</option>
                      <option value='EVENT_ORGANIZER'> Event Organiser</option>
                      <option value='HOSPITAL'> Hospital</option>
                      {/* <option value="MEDIA_AGENCY"> Media Agency</option>
                      <option value="DIGITAL_AGENCY"> Digital Agency</option>
                      <option value="PR_AGENCY"> PR Agency</option> */}
                    </select>
                  </div>
                  {errors.type && (
                    <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                      {errors.type.message}
                    </p>
                  )}
                </div>

                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    {getNamesOfEvents(selectedType)}
                    <span className='font-[400]'> (Required)</span>
                  </label>
                  <div className='relative'>
                    <input
                      type='text'
                      placeholder='Enter your Company Name'
                      {...register('companyName', {
                        required: 'Company Name is required',
                      })}
                      className={`form-control border mt-1 p-2 rounded w-full ${
                        errors.companyName
                          ? 'border border-[#B91C1C]'
                          : 'border border-gray-300'
                      }`}
                      style={{
                        outline: errors.companyName ? '2px solid red' : 'none',
                      }}
                    />
                    {/* {errors.companyName && (
                      <div className="absolute inset-y-0 right-0 pr-3 bottom-1/4 flex items-center pointer-events-none">
                        <img src="/images/Exclamation_circle.svg" />
                      </div>
                    )} */}
                    {errors.companyName && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.companyName.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Contact Person Name{' '}
                    <span className='font-[400]'> (Required)</span>
                  </label>
                  <div className='relative'>
                    <input
                      type='text'
                      placeholder='Enter your Contact Person Name'
                      {...register('contactPersonName', {
                        required: 'Contact person name is required',
                      })}
                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                        errors.contactPersonName
                          ? 'border border-[#B91C1C]'
                          : 'border border-gray-300'
                      }`}
                      style={{
                        outline: errors.contactPersonName
                          ? '2px solid red'
                          : 'none',
                      }}
                    />
                    {/* {errors.contactPersonName &&
                      touchedFields.contactPersonName && (
                        <div className="absolute inset-y-0 right-0 pr-3 bottom-1/4 flex items-center pointer-events-none">
                          <img src="/images/Exclamation_circle.svg" />
                        </div>
                      )} */}
                    {errors.contactPersonName && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.contactPersonName.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Email <span className='font-[400]'> (Required)</span>
                  </label>
                  <div className='relative'>
                    <input
                      type='email'
                      placeholder='Enter your email address'
                      {...register('email', {
                        required: 'Email is required',
                        pattern: {
                          value:
                            /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                          message: 'Please enter a valid email id',
                        },
                      })}
                      disabled={!!userId || !!leadId}
                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                        errors.email
                          ? 'border border-[#B91C1C]'
                          : 'border border-gray-300'
                      }`}
                      style={{
                        outline: errors.email ? '2px solid red' : 'none',
                      }}
                    />
                    {/* {errors.email && touchedFields.email && (
                      <div className="absolute inset-y-0 right-0 pr-3 bottom-1/4 flex items-center pointer-events-none">
                        <img src="/images/Exclamation_circle.svg" />
                      </div>
                    )} */}
                    {errors.email && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.email.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Pitched By
                    {convertBookForm && (
                      <span className='font-[400]'> (Required)</span>
                    )}
                  </label>

                  <Select
                    options={assignToSubUsers.map((item) => ({
                      value: item.adminUserId,
                      label: `${item.firstName} ${
                        item.lastName
                      } (${getRoleDisplayName(item.role)})`,
                    }))}
                    value={
                      assignToSubUsers
                        .map((item) => ({
                          value: item.adminUserId,
                          label: `${item.firstName} ${
                            item.lastName
                          } (${getRoleDisplayName(item.role)})`,
                        }))
                        .find((option) => option.value === selectedPitched) ||
                      null
                    }
                    onChange={(selectedOption) => {
                      setSelectedPitched(selectedOption?.value);
                      setTouched(true); // Mark as touched when a selection is made
                    }}
                    onBlur={() => setTouched(true)} // Mark as touched when the field loses focus
                    onMenuScrollToBottom={handleMenuScrollToBottom}
                    onInputChange={handleInputChange}
                    placeholder='Select User'
                    noOptionsMessage={() => 'No users found'}
                    className={`custom-dropdown ${
                      isFieldInvalid ? 'border-red-500' : ''
                    }`} // Add red border if invalid
                  />
                  {isFieldInvalid && (
                    <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                      User selection is required.
                    </p>
                  )}
                </div>
                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Designation
                    {convertBookForm && (
                      <span className='font-[400]'> (Required)</span>
                    )}
                  </label>
                  <div className='relative'>
                    <input
                      type='text'
                      placeholder='Enter your Designation'
                      {...register('contactPersonRole', {
                        required: convertBookForm
                          ? 'Designation is requied '
                          : false,
                      })}
                      className='form-control mt-1 p-2 rounded w-full font-medium'
                    />
                    {errors.contactPersonRole && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.contactPersonRole.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Continent <span className='font-[400]'> (Required)</span>
                  </label>
                  <select
                    value={selectedContinent} // ✅ Keeps the selected value visible
                    {...register('mtContinentDto',{
                      required: 'Continent is required'
                    })}
                    onChange={handleContinentChange}
                    className='form-control border p-2 rounded mt-1 w-full custom-dropdown'
                  >
                    <option value=''>Select Continent</option>
                    {continents.map((item) => (
                      <option key={item.id} value={String(item.id)}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {errors.mtContinentDto&& (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.mtContinentDto?.message}
                      </p>
                    )}
                </div>

                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Call back date{' '}{convertBookForm && <span className='font-normal'>(Required)</span>}
                    {/* <span className="font-[400]"> (Required)</span> */}
                  </label>
                  <div className=''>
                    <input
                      type='date'
                      min={
                        todayDate
                        // watch("callBackDate")
                        //   ? moment(watch("callBackDate"), "YYYY-MM-DD").format("YYYY-MM-DD") // Use the API-fetched callBackDate
                        //   : today // Use today's date if no callBackDate is available
                      }
                      onClick={handleDateClick}
                      // onFocus={(e) => e.target.showPicker()}
                      placeholder='Enter your Call back date'
                      {...register('callBackDate', {
                        required: convertBookForm ? "Call back date is required " : false,
                      })}
                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                        errors.callBackDate
                          ? 'border border-[#B91C1C]'
                          : 'border border-gray-300'
                      }`}
                      value={watch('callBackDate')}
                    />
                    {errors.callBackDate && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.callBackDate.message}
                      </p>
                    )}
                  </div>
                </div>
                {/* </div> */}
                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Country{' '}
                    {convertBookForm && (
                      <span className='font-[400]'> (Required)</span>
                    )}
                  </label>
                  <select
                    value={selectedCountry || ''}
                    {...register('mtCountryDto', {
                      required: convertBookForm
                        ? 'Country  is requied '
                        : false,
                    })}
                    onChange={(e) => handleCountryChange(e, 'country')}
                    className={`form-control border p-2 rounded mt-1 w-full custom-dropdown`}
                  >
                    <option value=''>Select Country</option>
                    {mtContryData.map((item: any) => (
                      <option
                        key={item.id}
                        value={item.id !== null ? item.id : ''}
                      >
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {errors.mtCountryDto?.message && (
                    <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                      {String(errors.mtCountryDto?.message)}{' '}
                      {/* Convert to string explicitly */}
                    </p>
                  )}
                </div>

                {selectedCountry == '1' && (
                  <div className='form-group mb-4 sm:mb-0'>
                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                      GST No{' '}
                      {userId && convertBookForm && (
                        <span className='font-[400]'> (Required)</span>
                      )}
                    </label>
                    <div className='relative'>
                      <input
                        type='text'
                        placeholder='Enter your GST No'
                        {...register('gstNo', {
                          required:
                            userId && convertBookForm
                              ? 'GST number is required'
                              : false,
                          pattern: {
                            value:
                              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
                            message: 'Invalid GST number format',
                          },
                        })}
                        className={`form-control border mt-1 p-2 rounded w-full ${
                          errors.gstNo
                            ? 'border border-[#B91C1C]'
                            : 'border border-gray-300'
                        }`}
                        style={{
                          outline: errors.gstNo ? '2px solid red' : 'none',
                        }}
                      />
                      {/* {errors.gstNo && (
                     <div className="absolute inset-y-0 right-0 pr-3 bottom-1/4 flex items-center pointer-events-none">
                       <img src="/images/Exclamation_circle.svg" alt="Error" />
                     </div>
                   )} */}
                      {errors.gstNo && (
                        <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                          {errors.gstNo.message}
                        </p>
                      )}
                    </div>
                  </div>
                )}
                {/* <div className="grid grid-cols-2 gap-4"> */}
                <div className=' form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Contact Number
                    {convertBookForm && (
                      <span className='font-[400]'> (Required)</span>
                    )}
                  </label>

                  <div className='flex border border-gray-300 rounded mt-1 form-control'>
                    <select
                      value={phoneCode.isoCode || ''}
                      {...register('phoneisoCode')}
                      onChange={(e) => phoneNuberChange(e)}
                      className='border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none'
                    >
                      {mtContryData.map((item: any) => (
                        <option key={item.id} value={item.isoCode || ''}>
                          {item.isoCode}
                        </option>
                      ))}
                    </select>
                    <input
                      type='text'
                      placeholder='Enter Phone Number'
                      {...register('contactNo', {
                        required: convertBookForm
                          ? 'Contact number is required'
                          : false,
                      })}
                      onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                      className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                    />
                  </div>
                  {errors.contactNo && (
                    <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                      {errors.contactNo.message}
                    </p>
                  )}
                </div>

                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Direct Number{' '}{convertBookForm && (
                      <span className='font-[400]'> (Required)</span>
                    )}
                  </label>
                  <div className='flex border border-gray-300 rounded mt-1 form-control'>
                    <select
                      value={alternatephoneCode.isoCode || ''}
                      {...register('alternateIsoCode')}
                      onChange={(e) => altPhoneNuberChange(e)}
                      className='border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none'
                    >
                      {mtContryData.map((item: any) => (
                        <option key={item.id} value={item.isoCode || ''}>
                          {item.isoCode}
                        </option>
                      ))}
                    </select>
                    <input
                      type='text'
                      placeholder='Enter Alternate Phone Number '
                      {...register('directNo',{
                        required: convertBookForm
                          ? 'Direct number is required'
                          : false,
                      })}
                      onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                      className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                    />
                  </div>
                  {errors.directNo && (
                    <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                      {errors.directNo.message}
                    </p>
                  )}
                </div>
                {/* </div> */}
                <div className='form-group sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Website {convertBookForm && <span className='font-normal'>(Required)</span>}
                    {/* {convertBookForm &&
                      <span className="font-[400]"> (Required)</span>
                    } */}
                  </label>
                  <div className='relative'>
                    <input
                      type='text'
                      placeholder='Enter your Website'
                      {...register('website', {
                        required: convertBookForm ? "Website is required " : false,
                        pattern:{
                          value: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
                          message: 'Please enter a valid website URL (e.g., https://www.example.com).'

                        }
                      })}
                      className={`form-control border mt-1 p-2 rounded w-full ${
                        errors.website
                          ? 'border border-[#B91C1C]'
                          : 'border border-gray-300'
                      }`}
                      style={{
                        outline: errors.website ? '2px solid red' : 'none',
                      }}
                    />
                    {errors.website && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.website.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className='form-group'>
                  <label
                    htmlFor='username'
                    className='block text-[#374151] font-semibold text-sm font-Inter'
                  >
                    Street Address {convertBookForm && <span className='font-normal'>(Required)</span>}
                  </label>
                  <div className='input-group mt-2'>
                    <input
                      {...register('streetAddress', {
                        required: convertBookForm
                          ? ' Street Address  is required'
                          : false,
                      })}
                      type='text'
                      placeholder='eg. Street 7'
                      className='form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md'
                    />
                    {errors.streetAddress && (
                      <p className='text-primary-color text-sm mt-1'>
                        {errors.streetAddress.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className='form-group'>
                  <label
                    htmlFor='username'
                    className='block text-[#374151] font-semibold text-sm'
                  >
                    Location{' '}
                    {convertBookForm && (
                      <span className='text-gray-900 font-normal text-sm ml-2'>
                        (Required)
                      </span>
                    )}
                  </label>
                  <div className='input-group mt-2'>
                    <input
                      {...register('apartment', {
                        required: convertBookForm
                          ? 'Location is required'
                          : false,
                      })}
                      type='text'
                      placeholder='Enter Location'
                      className='form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md'
                    />
                    {errors.apartment && (
                      <p className='text-primary-color text-sm mt-1'>
                        {errors.apartment.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className='form-group'>
                  <label
                    htmlFor='username'
                    className='mb-1 block text-[#374151] font-semibold text-sm'
                  >
                    State{' '}
                    {convertBookForm && (
                      <span className='text-gray-900 font-normal text-sm ml-2'>
                        (Required)
                      </span>
                    )}
                  </label>
                  <div className='input-group'>
                    {selectedCountry == '1' ? (
                      <select
                        {...register('state', {
                          required: convertBookForm
                            ? 'State is required'
                            : false,
                        })}
                        className={`form-control p-2 rounded mt-1 w-full ${
                          errors.state
                            ? 'border-[#B91C1C] border-2'
                            : 'border-gray-300 border'
                        }`}
                      >
                        <option value=''>Select state</option>
                        {state.map((item: any) => (
                          <option
                            key={item.id}
                            value={item.id !== null ? item.id : ''}
                          >
                            {item.name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        {...register('state', {
                          required: convertBookForm
                            ? 'State is required'
                            : false,
                        })}
                        type='text'
                        placeholder='Enter state'
                        className='form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md'
                      />
                    )}

                    {errors.state && (
                      <p className='text-primary-color text-sm mt-1'>
                        {errors.state.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className='form-group'>
                  <label
                    htmlFor='username'
                    className='mb-1 block text-[#374151] font-semibold text-sm'
                  >
                    City{' '}
                    {convertBookForm && (
                      <span className='text-gray-900 font-normal text-sm ml-2'>
                        (Required)
                      </span>
                    )}
                  </label>
                  <div className='input-group'>
                    <input
                      {...register('city', {
                        required: convertBookForm ? 'City is required' : false,
                      })}
                      type='text'
                      placeholder='Enter City Name'
                      className='form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md'
                    />
                    {errors.city && (
                      <p className='text-primary-color text-sm mt-1'>
                        {errors.city.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className='form-group'>
                  <label
                    htmlFor='username'
                    className='mb-1 block text-[#374151] font-semibold text-sm'
                  >
                    Postal Code{' '}
                    {convertBookForm && (
                      <span className='text-gray-900 font-normal text-sm ml-2'>
                        (Required)
                      </span>
                    )}
                  </label>
                  <div className='input-group'>
                    <input
                      {...register('postalCode', {
                        required: convertBookForm
                          ? 'Postal Code is required'
                          : false,
                      })}
                      onInput={(e: any) =>
                        (e.target.value = e.target.value.replace(/\D/g, ''))
                      }
                      type='text'
                      placeholder='Enter Postal Code'
                      className='form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md'
                    />
                    {errors.postalCode && (
                      <p className='text-primary-color text-sm mt-1'>
                        {errors.postalCode.message}
                      </p>
                    )}
                  </div>
                </div>

                {submittedData?.source !== 'WEBSITE' && (
                  <div className='form-group mb-4 sm:mb-0'>
                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                      Source URL
                      {/* {convertBookForm &&
                      <span className="font-[400]"> (Required)</span>
                    } */}
                    </label>
                    <div className='relative'>
                      <input
                        type='text'
                        placeholder='Enter Source URL'
                        {...register('sourceUrl', {
                          // required: convertBookForm ? "Source URL is required" : false,
                          pattern: {
                            value:
                              /^(https?:\/\/)(localhost|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))(:\d+)?(\/[^\s]*)?$/,
                            message: 'Enter a valid URL',
                          },
                        })}
                        className={`form-control border mt-1 p-2 rounded w-full ${
                          errors.sourceUrl
                            ? 'border border-[#B91C1C]'
                            : 'border border-gray-300'
                        }`}
                        style={{
                          outline: errors.sourceUrl ? '2px solid red' : 'none',
                        }}
                      />
                      {errors.sourceUrl && (
                        <p className='text-[#B91C1C] text-sm'>
                          {errors.sourceUrl.message}
                        </p>
                      )}
                    </div>
                  </div>
                )}
                {submittedData?.source !== 'WEBSITE' && (
                  <div
                    className={`form-group ${
                      (
                        userId
                          ? submittedData?.type === 'COMPANY'
                          : selectedType === 'COMPANY'
                      )
                        ? 'mb-1'
                        : 'mb-1'
                    }`}
                  >
                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                      Source
                      {/* {convertBookForm &&
                      <span className="font-[400]"> (Required)</span>
                    } */}
                    </label>
                    <div className='relative'>
                      <select
                        {...register('source')}
                        className={`form-control p-2 rounded mt-1 w-full ${
                          errors.source
                            ? 'border-[#B91C1C] border-2'
                            : 'border-gray-300 border'
                        }`}
                      >
                        <option value=''>Select Source</option>
                        <option value='INTERNAL'>Internal</option>
                        <option value='REFRAL'>Refral</option>
                        <option value='INBOUND_CALL'>Inbound Call</option>
                        <option value='INT_PROMOTIONS'> Int Promotions </option>
                        <option value='SOCIAL_MEDIA'> Social Media</option>
                        {/* <option value="WEBSITE">Website</option> */}
                      </select>
                      {/* {errors.source && (
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                        <img src="/images/Exclamation_circle.svg" alt="Error" />
                      </div>
                    )} */}
                    </div>
                    {errors.source && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.source.message}
                      </p>
                    )}
                  </div>
                )}
                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Feedback
                  </label>
                  <div className='relative'>
                    <textarea
                      placeholder='Enter the Feedback'
                      rows={2}
                      {...register('feedback')}
                      className=' border mt-1 p-2 rounded w-full'
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className='bg-white rounded-md mt-8'>
                <div className='w-full h-auto'>
                  <div className='w-full sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4'>
                    <div className=''>
                      <p className='font-bold text-xl pb-4 border-b border-gray-200 mb-5'>
                        {userId && convertBookForm
                          ? 'Selected Services'
                          : 'Select Services'}

                        {/* Booking Form for {submittedData?.companyName} */}
                      </p>
                      <div className='grid grid-cols-2 gap-10'>
                        <div className='form-group mb-4 sm:mb-0 '>
                          <div className='mb-[20px]'>
                            <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                              Type{' '}
                              <span className='font-[400]'> (Required)</span>{' '}
                            </label>
                            <div className='relative'>
                              <select
                                {...register('types', {
                                  required: 'Type is required',
                                })}
                                onChange={handleTypeChanges}
                                disabled={name !== 'converToProposals' && convertBookForm !=='convertToBookingForm' &&
                                  proposalFrom !== 'activeVendors'
                                  && (isEditMode || Boolean(userId) || Boolean(leadId)) }
                                className={`form-control p-2 rounded mt-1 w-full ${
                                  errors.types
                                    ? 'border-[#B91C1C] border-2'
                                    : 'border-gray-300 border'
                                }`}
                              >
                                <option value=''>Select type</option>
                                {submittedData?.proposalType ===
                                  'EVENT_ORGANIZER' ||
                                selectedType === 'EVENT_ORGANIZER' ||
                                submittedData?.type === 'EVENT_ORGANIZER' ? (
                                  <>
                                    <option value='PAID'>Paid</option>
                                    {/* <option value="BARTER">Barter</option> */}
                                  </>
                                ) : (
                                  <>
                                    <option value='PAID'>Paid</option>
                                    <option value='TRIAL'>Trial</option>
                                    <option value='INVITE'>Invite</option>
                                  </>
                                )}
                              </select>
                            </div>
                            {errors.types && (
                              <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                {errors.types.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div
                          className='form-group mb-[20px] sm:mb-0'
                          style={{ marginBottom: '20px' }}
                        >
                          <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                            Booking date{' '}
                            <span className='font-[400]'> (Required)</span>
                          </label>
                          <div className='relative'>
                            <input
                              type='date'
                              min={today}
                              value={selectedDate}
                              onClick={handleDateClick}
                              {...register('bookingDate', {
                                required: 'Booking date is required',
                                onChange: (e) => handleDateChange(e), // Use the modified handler
                              })}
                              className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                errors.bookingDate
                                  ? 'border border-[#B91C1C]'
                                  : 'border border-gray-300'
                              }`}
                            />
                            {errors.bookingDate && (
                              <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                {errors.bookingDate.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      {selectedTypes === 'PAID' && (
                        <div className='form-group sm:mb-0 md:mb-5 grid grid-cols-2 pr-10'>
                         <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                            Booking value
                            {selectedTypes === 'PAID' && (
                              <span className='font-[400]'> (Required)</span>
                            )}
                          </label> 
                          <div></div>
                          <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden'>
                            <div className='flex items-center px-3 text-gray-700 font-semibold text-sm'>
                              {getCurrencySymbol(
                                watch(
                                  'mtCurrencyDto'
                                )?.id?.toString() || ''
                              )}
                            </div>
                            <input
                              type='text'
                              placeholder='0.00'
                              {...register('value', {
                                required:
                                  selectedTypes === 'PAID'
                                    ? 'Booking value is required'
                                    : false,
                              })}
                              onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                              className={`w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none ${
                                errors.value ? 'border-red-500' : ''
                              }`}
                            />

                            <Controller
                              name='mtCurrencyDto'
                              control={control}
                              rules={{
                                required:
                                  selectedTypes === 'PAID'
                                    ? 'Currency is required'
                                    : false,
                              }}
                              render={({ field }) => (
                                <select
                                  {...field}
                                  value={field.value?.id || ''}
                                  onChange={(e) => {
                                    const selectedId = Number(e.target.value);
                                    const selectedCurrency =
                                      mtCurrencyData.find(
                                        (c) => c.id === selectedId
                                      );
                                    // Set the complete currency object
                                    field.onChange(selectedCurrency || null);
                                  }}
                                  className={`bg-white py-2 text-sm font-semibold text-gray-700 focus:outline-none ${
                                    errors.mtCurrencyDto ? 'border-red-500' : ''
                                  }`}
                                >
                                  <option value=''>Select</option>
                                  {mtCurrencyData.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.name}
                                    </option>
                                  ))}
                                </select>
                              )}
                            />
                          </div>
                          <div></div>
                          {errors.value && (
                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                              {errors.value.message}
                            </p>
                          )}
                          {errors.mtCurrencyDto && (
                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                              {errors.mtCurrencyDto.message ||
                                'Currency selection is required'}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {(submittedData?.proposalType === 'HOSPITAL' ||
                submittedData?.type === 'HOSPITAL' ||
                submittedData?.proposalType === 'EVENT_ORGANIZER' ||
                submittedData?.type === 'EVENT_ORGANIZER' ||
                submittedData?.proposalType === 'COMPANY' ||
                selectedType === 'COMPANY' ||
                selectedType === 'HOSPITAL' ||
                selectedType === 'EVENT_ORGANIZER' ||
                submittedData?.type === 'COMPANY') && (
                <>
                  {(selectedTypes === 'PAID' || selectedType === 'BARTER') && (
                    <>
                      <p className='pt-4 text-xl font-bold font-sans mb-4 pb-4 border-y border-x-gray-200 mt-2'>
                        Services:{' '}
                        <span className='font-[400] text-sm text-gray-700'>
                          {' '}
                          (Required)
                        </span>
                      </p>
                      <div className='bg-white rounded-md'>
                        <div className='w-full  h-auto'>
                          <div className='w-full sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4'>
                            <div className='grid grid-cols-1 gap-4'>
                              {(submittedData?.proposalType === 'HOSPITAL' ||
                                selectedType === 'HOSPITAL' ||
                                submittedData?.type === 'HOSPITAL') &&
                                !formData?.isHospitalProfilingExist && (
                                  <>
                                    <div className='flex items-center gap-3 pb-2'>
                                      <input
                                        type='checkbox'
                                        checked={formData.isHospitalProfiling}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            'isHospitalProfiling'
                                          )
                                        }
                                        className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                      />
                                      <p className='text-[#111827] text-sm font-bold'>
                                        Hospital Profiling
                                      </p>
                                    </div>
                                  </>
                                )}
                              {(submittedData?.proposalType ===
                                'EVENT_ORGANIZER' ||
                                selectedType === 'EVENT_ORGANIZER' ||
                                submittedData?.type === 'EVENT_ORGANIZER') && (
                                <>
                                  <div className='flex items-center gap-3 pb-2'>
                                    <input
                                      type='checkbox'
                                      checked={formData.isEventListing}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          'isEventListing'
                                        )
                                      }
                                      className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                    />
                                    <p className='text-[#111827] text-sm font-bold'>
                                      Event Listing
                                    </p>
                                  </div>
                                  {formData.isEventListing && (
                                    <>
                                      <div className='mb-1'>
                                        <input
                                          type='text'
                                          placeholder='Number of Events'
                                          {...register('noOfEvents', {
                                            required:
                                              formData.isEventListing
                                                ? 'Number of posts are required'
                                                : false,
                                          })}
                                           onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                          className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                            errors.noOfEvents
                                              ? 'border border-[#B91C1C]'
                                              : 'border border-gray-300'
                                          }`}
                                          style={{
                                            outline: errors.noOfEvents
                                              ? '2px solid red'
                                              : 'none',
                                          }}
                                        />
                                        {errors.noOfEvents && (
                                          <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                            {errors.noOfEvents.message}
                                          </p>
                                        )}
                                      </div>

                                      <div className='flex gap-4'>
                                        <div className=' form-group w-full'>
                                          <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                            Start Date{' '}
                                          </label>
                                          <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden'>
                                            <input
                                              type='date'
                                              min={today}
                                              onClick={handleDateClick}
                                              placeholder='Enter Start Date'
                                              {...register('eventListingFrom', {
                                                required:
                                                  'Start date is required',
                                                onChange:
                                                  handleStartDateChange2,
                                              })}
                                              className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                            />
                                          </div>
                                          {errors.eventListingFrom && (
                                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                              {errors.eventListingFrom.message}
                                            </p>
                                          )}
                                        </div>
                                        <div className='form-group w-full'>
                                          <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                            End Date{' '}
                                          </label>
                                          <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden'>
                                            <input
                                              type='date'
                                              onClick={handleDateClick}
                                              min={endDate2}
                                              placeholder='Enter End Date'
                                              {...register('eventListingTo', {
                                                required:
                                                  'End date is required',
                                              })}
                                              className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                            />
                                          </div>
                                          {errors.eventListingTo && (
                                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                              {errors.eventListingTo.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </>
                              )}
                              {(submittedData?.proposalType === 'COMPANY' ||
                                selectedType === 'COMPANY' ||
                                submittedData?.type === 'COMPANY') &&
                                !formData?.isCompanyProfilingExist && (
                                  <div className='flex items-center gap-3 pb-2'>
                                    <input
                                      type='checkbox'
                                      checked={formData.isCompanyProfiling}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          'isCompanyProfiling'
                                        )
                                      }
                                      className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                    />
                                    <p className='text-[#111827] text-sm font-bold'>
                                      Company Profiling
                                    </p>
                                  </div>
                                )}
                              <div className='grid grid-cols-2 gap-4'>
                                <div className='flex items-center gap-3 pb-2'>
                                  <input
                                    type='checkbox'
                                    checked={formData.isContentMarketing}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        'isContentMarketing'
                                      )
                                    }
                                    className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                  />
                                  <p className='text-[#111827] text-sm font-bold'>
                                    Content Marketing
                                  </p>
                                </div>
                                <div></div>

                                {formData.isContentMarketing && (
                                  <div className='mb-1'>
                                    <input
                                      type='text'
                                      placeholder='Number of Posts'
                                      {...register('noOfPosts', {
                                        required: formData.isContentMarketing
                                          ? 'Number of posts are required'
                                          : false,
                                      })}
                                       onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                        errors.noOfPosts
                                          ? 'border border-[#B91C1C]'
                                          : 'border border-gray-300'
                                      }`}
                                      style={{
                                        outline: errors.noOfPosts
                                          ? '2px solid red'
                                          : 'none',
                                      }}
                                    />
                                    {errors.noOfPosts && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.noOfPosts.message}
                                      </p>
                                    )}
                                  </div>
                                )}

                                {/* <div></div> */}
                              </div>
                              {formData.isContentMarketing && (
                                <div className='flex gap-4'>
                                  <div className=' form-group w-full'>
                                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                      Start Date{' '}
                                    </label>
                                    <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden'>
                                      <input
                                        type='date'
                                        min={today}
                                        onClick={handleDateClick}
                                        placeholder='Enter Start Date'
                                        {...register('contntMarktAdFrom', {
                                          required: 'Start date is required',
                                          onChange: handleStartDateChange2,
                                        })}
                                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                      />
                                    </div>
                                    {errors.contntMarktAdFrom && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.contntMarktAdFrom.message}
                                      </p>
                                    )}
                                  </div>
                                  <div className='form-group w-full'>
                                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                      End Date{' '}
                                    </label>
                                    <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden'>
                                      <input
                                        type='date'
                                        onClick={handleDateClick}
                                        min={endDate2}
                                        placeholder='Enter End Date'
                                        {...register('contntMarktAdTo', {
                                          required: 'End date is required',
                                        })}
                                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                      />
                                    </div>
                                    {errors.contntMarktAdTo && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.contntMarktAdTo.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )}

                              <div className='flex items-center gap-3 pb-2'>
                                <input
                                  type='checkbox'
                                  checked={formData.isBannerAds}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, 'isBannerAds')
                                  }
                                  className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                />
                                <p className='text-[#111827] text-sm font-bold'>
                                  Banner Ads (Website)
                                </p>
                              </div>
                              {formData.isBannerAds && (
                                <div className='grid grid-cols-2 gap-4'>
                                  <div className=' form-group'>
                                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                      Start Date{' '}
                                    </label>
                                    <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden '>
                                      <input
                                        type='date'
                                        min={today}
                                        onClick={handleDateClick}
                                        placeholder='Enter Start Date'
                                        {...register('bannerAdFrom', {
                                          required: formData.isBannerAds
                                            ? 'Start Date is required'
                                            : false,
                                          onChange: handleStartDateChange1, // Move onChange here
                                        })}
                                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                      />
                                    </div>
                                    {errors.bannerAdFrom && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.bannerAdFrom.message}
                                      </p>
                                    )}
                                  </div>
                                  <div className='form-group '>
                                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                      End Date{' '}
                                    </label>
                                    <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden'>
                                      <input
                                        type='date'
                                        onClick={handleDateClick}
                                        placeholder='Enter End Date'
                                        min={endDate1}
                                        {...register('bannerAdTo', {
                                          required: formData.isBannerAds
                                            ? 'End Date is required'
                                            : false,
                                        })}
                                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                      />
                                    </div>
                                    {errors.bannerAdTo && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.bannerAdTo.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )}
                              {formData.isBannerAds && (
                                <div className='grid grid-cols-2 gap-4'>
                                  <div className='form-group mb-4 sm:mb-0 w-full'>
                                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                      Number of Banners
                                    </label>
                                    <div className='relative'>
                                      <input
                                        type='text'
                                        placeholder='Enter number of banners'
                                        {...register('noOfBanners', {
                                          required: formData.isBannerAds
                                            ? 'Number of Banners is required'
                                            : false,
                                        })}
                                         onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                        className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                          errors.noOfBanners
                                            ? 'border border-[#B91C1C]'
                                            : 'border border-gray-300'
                                        }`}
                                        style={{
                                          outline: errors.noOfBanners
                                            ? '2px solid red'
                                            : 'none',
                                        }}
                                      />
                                      {errors.noOfBanners && (
                                        <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                          {errors.noOfBanners.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className='grid grid-cols-2 gap-4'>
                                <div className='flex items-center gap-3 pb-2 '>
                                  <input
                                    type='checkbox'
                                    checked={formData.isEmailMarketing}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        'isEmailMarketing'
                                      )
                                    }
                                    className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                  />
                                  <p className='text-[#111827] text-sm font-bold'>
                                    Email Marketing
                                  </p>
                                </div>
                                <div></div>
                                {formData.isEmailMarketing && (
                                  <div className='w-full'>
                                    <input
                                      type='text'
                                      placeholder='Recepients Counts Given'
                                      {...register('noOfRecipients', {
                                        required:
                                          'Number of Recipients is required',
                                      })}
                                       onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                        errors.noOfRecipients
                                          ? 'border border-[#B91C1C]'
                                          : 'border border-gray-300'
                                      }`}
                                      style={{
                                        outline: errors.noOfRecipients
                                          ? '2px solid red'
                                          : 'none',
                                      }}
                                    />

                                    {errors.noOfRecipients && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.noOfRecipients.message}
                                      </p>
                                    )}
                                    <input
                                      type='text'
                                      placeholder="Number of EDM'S"
                                      {...register('noOfEdms', {
                                        required: 'Number of EDMS is required',
                                      })}
                                       onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                      className={`form-control p-2 rounded w-full font-medium mt-5 ${
                                        errors.noOfEdms
                                          ? 'border border-[#B91C1C]'
                                          : 'border border-gray-300'
                                      }`}
                                      style={{
                                        outline: errors.noOfEdms
                                          ? '2px solid red'
                                          : 'none',
                                      }}
                                    />
                                    {errors.noOfEdms && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.noOfEdms.message}
                                      </p>
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className='flex items-center gap-3 pb-2'>
                                <input
                                  type='checkbox'
                                  checked={formData.isNewsLetterAds}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, 'isNewsLetterAds')
                                  }
                                  className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                />
                                <p className='text-[#111827] text-sm font-bold'>
                                  Ads in e-newsletter
                                </p>
                              </div>
                              {formData.isNewsLetterAds && (
                                <div className='grid grid-cols-2 gap-4'>
                                  <div className=' form-group'>
                                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                      Start Date{' '}
                                    </label>
                                    <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden '>
                                      <input
                                        type='date'
                                        min={today}
                                        onClick={handleDateClick}
                                        placeholder='Enter Start Date'
                                        {...register('newsLetterAdFrom', {
                                          required: 'Start date is required',
                                          onChange: handleStartDateChange,
                                        })}
                                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                      />
                                    </div>
                                    {errors.newsLetterAdFrom && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.newsLetterAdFrom.message}
                                      </p>
                                    )}
                                  </div>
                                  <div className='form-group '>
                                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                      End Date{' '}
                                    </label>
                                    <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden '>
                                      <input
                                        type='date'
                                        onClick={handleDateClick}
                                        min={endDate}
                                        placeholder='Enter End Date'
                                        {...register('newsLetterAdTo', {
                                          required: 'End date is required',
                                        })}
                                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                      />
                                    </div>
                                    {errors.newsLetterAdTo && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.newsLetterAdTo.message}
                                      </p>
                                    )}
                                  </div>
                                  <div className='w-full'>
                                    <input
                                      type='text'
                                      placeholder='Number of Banners'
                                      {...register('noOfNewsBanners', {
                                        required:
                                          'Number of banners is required',
                                      })}
                                       onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                        errors.noOfNewsBanners
                                          ? 'border border-[#B91C1C]'
                                          : 'border border-gray-300'
                                      }`}
                                      style={{
                                        outline: errors.noOfNewsBanners
                                          ? '2px solid red'
                                          : 'none',
                                      }}
                                    />
                                    {errors.noOfNewsBanners && (
                                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                        {errors.noOfNewsBanners.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )}

                              <div className='flex items-center gap-3'>
                                <input
                                  type='checkbox'
                                  checked={formData.isPrintAd}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, 'isPrintAd')
                                  }
                                  className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                />
                                <p className='text-[#111827] text-sm font-bold'>
                                  Print Advertisement
                                </p>
                              </div>
                              <div className='grid grid-cols-2 gap-4'>
                                {formData.isPrintAd && (
                                  <div className='form-group'>
                                    <div className='relative mb-5'>
                                      <textarea
                                        placeholder='Add type of Advertisement..'
                                        rows={2}
                                        {...register('printAdd', {
                                          required: 'Description is required',
                                        })}
                                        className=' border mt-1 p-2 rounded w-full'
                                      ></textarea>
                                      {errors.printAdd && (
                                        <p className='text-[#B91C1C] font-[500] text-sm'>
                                          {errors.printAdd.message}
                                        </p>
                                      )}
                                    </div>
                                    <div></div>
                                    <div className=''>
                                      <input
                                        type='text'
                                        placeholder={
                                          submittedData?.proposalType ===
                                            'EVENT_ORGANIZER' ||
                                          selectedType === 'EVENT_ORGANIZER' ||
                                          submittedData?.type ===
                                            'EVENT_ORGANIZER'
                                            ? 'Number of Advertisements'
                                            : 'Number of Issues'
                                        }
                                         onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                        {...register('noOfPrintAds', {
                                          required:
                                            submittedData?.proposalType ===
                                              'EVENT_ORGANIZER' ||
                                            selectedType ===
                                              'EVENT_ORGANIZER' ||
                                            submittedData?.type ===
                                              'EVENT_ORGANIZER'
                                              ? 'Number of advertisements is required'
                                              : 'Number of issues is required',
                                        })}
                                        className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                          errors.noOfPrintAds
                                            ? 'border border-[#B91C1C]'
                                            : 'border border-gray-300'
                                        }`}
                                        style={{
                                          outline: errors.noOfPrintAds
                                            ? '2px solid red'
                                            : 'none',
                                        }}
                                      />
                                      {errors.noOfPrintAds && (
                                        <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                          {errors.noOfPrintAds.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className='grid grid-cols-2 gap-4'>
                                <div className='mb-14'>
                                  <p className='text-[#111827] text-sm font-bold'>
                                    Additional Services
                                  </p>
                                  <textarea
                                    placeholder='Write additional services each one in new line'
                                    rows={2}
                                    {...register('additionalService')}
                                    className='border mt-1 p-2 rounded w-full'
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' && e.shiftKey) {
                                        e.preventDefault();
                                        const textarea =
                                          e.target as HTMLTextAreaElement; // Cast e.target to HTMLTextAreaElement
                                        const start = textarea.selectionStart;
                                        const end = textarea.selectionEnd;
                                        const value = textarea.value;
                                        // Insert a newline character at the current cursor position
                                        textarea.value =
                                          value.slice(0, start) +
                                          '\n' +
                                          value.slice(end);
                                        // Set the cursor after the newline
                                        textarea.selectionStart =
                                          textarea.selectionEnd = start + 1;
                                      }
                                    }}
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {(selectedTypes === 'TRIAL' || selectedType === 'TRIAL') &&
                    (submittedData?.proposalType === 'COMPANY' ||
                      selectedType === 'EVENT_ORGANIZER' ||
                      selectedType === 'COMPANY' ||
                      selectedType === 'HOSPITAL' ||
                      submittedData?.type === 'COMPANY' ||
                      submittedData?.proposalType === 'HOSPITAL' ||
                      submittedData?.type === 'HOSPITAL' ||
                      submittedData?.proposalType === 'EVENT_ORGANIZER' ||
                      submittedData?.type === 'EVENT_ORGANIZER') && (
                      <>
                        <p className='pt-4 text-xl font-bold font-sans mb-4 pb-4 border-y border-x-gray-200 mt-2'>
                          Services:{' '}
                          <span className='font-[400] text-sm text-gray-700'>
                            {' '}
                            (Required)
                          </span>
                        </p>
                        <div className='bg-white rounded-md px-6l'>
                          <div className='w-full h-auto'>
                            <div className='w-full sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4'>
                              <div className='grid grid-cols-2 gap-4'>
                                <div className='flex items-center gap-3'>
                                  <input
                                    type='checkbox'
                                    checked={formData.isContentMarketing}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        'isContentMarketing'
                                      )
                                    }
                                    className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                  />
                                  <p className='text-[#111827] text-sm font-bold'>
                                    Content Marketing
                                  </p>
                                </div>
                                <div></div>
                                <div>
                                  {formData.isContentMarketing && (
                                    <>
                                      <div className='mb-1'>
                                        <input
                                          type='text'
                                          placeholder='Number of Posts'
                                          {...register('noOfPosts', {
                                            required:
                                              formData.isContentMarketing
                                                ? 'Number of posts are required'
                                                : false,
                                          })}
                                           onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                          className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                            errors.noOfPosts
                                              ? 'border border-[#B91C1C]'
                                              : 'border border-gray-300'
                                          }`}
                                          style={{
                                            outline: errors.noOfPosts
                                              ? '2px solid red'
                                              : 'none',
                                          }}
                                        />
                                        {errors.noOfPosts && (
                                          <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                            {errors.noOfPosts.message}
                                          </p>
                                        )}
                                      </div>
                                      {/* <p className="flex items-center justify-center font-semibold text-gray-700 text-sm my-2">
                                    OR
                                  </p> */}

                                      <div className='flex gap-4'>
                                        <div className=' form-group w-full'>
                                          <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                            Start Date{' '}
                                          </label>
                                          <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden'>
                                            <input
                                              type='date'
                                              min={today}
                                              onClick={handleDateClick}
                                              placeholder='Enter Start Date'
                                              {...register(
                                                'contntMarktAdFrom',
                                                {
                                                  required:
                                                    'Start date is required',
                                                  onChange:
                                                    handleStartDateChange2,
                                                }
                                              )}
                                              className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                            />
                                          </div>
                                          {errors.contntMarktAdFrom && (
                                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                              {errors.contntMarktAdFrom.message}
                                            </p>
                                          )}
                                        </div>
                                        <div className='form-group w-full'>
                                          <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                            End Date{' '}
                                          </label>
                                          <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden'>
                                            <input
                                              type='date'
                                              onClick={handleDateClick}
                                              min={endDate2}
                                              placeholder='Enter End Date'
                                              {...register('contntMarktAdTo', {
                                                required:
                                                  'End date is required',
                                              })}
                                              className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                            />
                                          </div>
                                          {errors.contntMarktAdTo && (
                                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                              {errors.contntMarktAdTo.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>

                                      {/* <div className="mt-3">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                      Trial end date{" "}
                                    </label>
                                    <div className="flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden">
                                      <input
                                        type="date"
                                        min={today}
                                        onClick={handleDateClick}
                                        // onChange={handleStartDateChange}
                                        placeholder="Enter Start Date"
                                        {...register("trialEndDate", {
                                          required: formData.isContentMarketing
                                            ? "Trial end Date is required"
                                            : false,
                                        })}
                                        className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                      />
                                    </div>
                                  </div>
                                  {errors.trialEndDate && (
                                    <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                      {errors.trialEndDate.message}
                                    </p>
                                  )} */}
                                    </>
                                  )}
                                </div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  {selectedTypes === 'INVITE' &&
                    (submittedData?.proposalType === 'COMPANY' ||
                      submittedData?.type === 'COMPANY' ||
                      submittedData?.proposalType === 'HOSPITAL' ||
                      submittedData?.type === 'HOSPITAL' ||
                      selectedType === 'COMPANY' ||
                      selectedType === 'EVENT_ORGANIZER' ||
                      selectedType === 'HOSPITAL' ||
                      submittedData?.proposalType === 'EVENT_ORGANIZER' ||
                      submittedData?.type === 'EVENT_ORGANIZER') && (
                      <>
                        <p className='pt-4 text-xl font-bold font-sans mb-4 pb-4 border-y border-x-gray-200 mt-2'>
                          Services:{' '}
                          <span className='font-[400] text-sm tetx-gray-700'>
                            {' '}
                            (Required)
                          </span>
                        </p>
                        <div className='bg-white rounded-md '>
                          <div className='w-full pt-6 scroolCls h-auto'>
                            <div className='w-full sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4'>
                              <div className='grid grid-cols-2 gap-4'>
                                {(submittedData?.proposalType === 'HOSPITAL' ||
                                  selectedType === 'HOSPITAL' ||
                                  submittedData?.type === 'HOSPITAL') &&
                                  !formData?.isHospitalProfilingExist && (
                                    <>
                                      <div className='flex items-center gap-3 pb-2'>
                                        <input
                                          type='checkbox'
                                          checked={formData.isHospitalProfiling}
                                          onChange={(e) =>
                                            handleCheckboxChange(
                                              e,
                                              'isHospitalProfiling'
                                            )
                                          }
                                          className=' form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                        />
                                        <p className='text-[#111827] text-sm font-bold'>
                                          Hospital Profiling
                                        </p>
                                      </div>

                                      <div></div>
                                    </>
                                  )}
                                {(submittedData?.proposalType === 'COMPANY' ||
                                  selectedType === 'COMPANY' ||
                                  submittedData?.type === 'COMPANY') &&
                                  !formData?.isCompanyProfilingExist && (
                                    <div className='flex items-center gap-3 pb-2 col-span-2'>
                                      <input
                                        type='checkbox'
                                        checked={formData.isCompanyProfiling}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            'isCompanyProfiling'
                                          )
                                        }
                                        className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                      />
                                      <p className='text-[#111827] text-sm font-bold'>
                                        Company Profiling
                                      </p>
                                    </div>
                                  )}
                                <div className='flex items-center gap-3'>
                                  <input
                                    type='checkbox'
                                    checked={formData.isContentMarketing}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        'isContentMarketing'
                                      )
                                    }
                                    className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                  />
                                  <p className='text-[#111827] text-sm font-bold'>
                                    Content Marketing
                                  </p>
                                </div>
                                <div></div>
                                <div>
                                  {formData.isContentMarketing && (
                                    <>
                                      <div className='mb-1'>
                                        <input
                                          type='text'
                                          placeholder='Number of Posts'
                                          {...register('noOfPosts', {
                                            required:
                                              formData.isContentMarketing
                                                ? 'Number of posts are required'
                                                : false,
                                          })}
                                           onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                          className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                            errors.noOfPosts
                                              ? 'border border-[#B91C1C]'
                                              : 'border border-gray-300'
                                          }`}
                                          style={{
                                            outline: errors.noOfPosts
                                              ? '2px solid red'
                                              : 'none',
                                          }}
                                        />
                                        {errors.noOfPosts && (
                                          <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                            {errors.noOfPosts.message}
                                          </p>
                                        )}
                                      </div>

                                      <div className='flex gap-4'>
                                        <div className=' form-group w-full'>
                                          <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                            Start Date{' '}
                                          </label>
                                          <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden'>
                                            <input
                                              type='date'
                                              min={today}
                                              onClick={handleDateClick}
                                              placeholder='Enter Start Date'
                                              {...register(
                                                'contntMarktAdFrom',
                                                {
                                                  required:
                                                    'Start date is required',
                                                  onChange:
                                                    handleStartDateChange2,
                                                }
                                              )}
                                              className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                            />
                                          </div>
                                          {errors.contntMarktAdFrom && (
                                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                              {errors.contntMarktAdFrom.message}
                                            </p>
                                          )}
                                        </div>
                                        <div className='form-group w-full'>
                                          <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                            End Date{' '}
                                          </label>
                                          <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden'>
                                            <input
                                              type='date'
                                              onClick={handleDateClick}
                                              min={endDate2}
                                              placeholder='Enter End Date'
                                              {...register('contntMarktAdTo', {
                                                required:
                                                  'End date is required',
                                              })}
                                              className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                            />
                                          </div>
                                          {errors.contntMarktAdTo && (
                                            <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                              {errors.contntMarktAdTo.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>

                                {(submittedData?.proposalType ===
                                  'EVENT_ORGANIZER' ||
                                  selectedType === 'EVENT_ORGANIZER' ||
                                  submittedData?.type ===
                                    'EVENT_ORGANIZER') && (
                                  <>
                                    {/* <div className="flex items-center gap-3 pb-2">
                                  <input
                                    type="checkbox"
                                    checked={formData.isEventProfiling}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        "isEventProfiling"
                                      )
                                    }
                                    className="p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4"
                                  />
                                  <p className="text-[#111827] text-sm font-bold">
                                    Event Organiser Profiling
                                  </p>
                                </div> */}
                                    <div></div>
                                    <div className='flex items-center gap-3 pb-2'>
                                      <input
                                        type='checkbox'
                                        checked={formData.isEventListing}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            'isEventListing'
                                          )
                                        }
                                        className='p-2 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B] rounded-lg border border-gray-300 h-4 w-4'
                                      />
                                      <p className='text-[#111827] text-sm font-bold'>
                                        Event Listing
                                      </p>
                                    </div>
                                    <div></div>
                                    <div>
                                      {formData.isEventListing && (
                                        <>
                                          <div className='mb-1'>
                                            <input
                                              type='text'
                                              placeholder='Number of Events'
                                              {...register('noOfEvents', {
                                                required:
                                                  formData.isEventListing
                                                    ? 'Number of posts are required'
                                                    : false,
                                              })}
                                               onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                              className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                                errors.noOfEvents
                                                  ? 'border border-[#B91C1C]'
                                                  : 'border border-gray-300'
                                              }`}
                                              style={{
                                                outline: errors.noOfEvents
                                                  ? '2px solid red'
                                                  : 'none',
                                              }}
                                            />
                                            {errors.noOfEvents && (
                                              <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                                {errors.noOfEvents.message}
                                              </p>
                                            )}
                                          </div>

                                          <div className='flex gap-4'>
                                            <div className=' form-group w-full'>
                                              <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                                Start Date{' '}
                                              </label>
                                              <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden'>
                                                <input
                                                  type='date'
                                                  min={today}
                                                  onClick={handleDateClick}
                                                  placeholder='Enter Start Date'
                                                  {...register(
                                                    'eventListingFrom',
                                                    {
                                                      required:
                                                        'Start date is required',
                                                      onChange:
                                                        handleStartDateChange2,
                                                    }
                                                  )}
                                                  className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                                />
                                              </div>
                                              {errors.eventListingFrom && (
                                                <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                                  {
                                                    errors.eventListingFrom
                                                      .message
                                                  }
                                                </p>
                                              )}
                                            </div>
                                            <div className='form-group w-full'>
                                              <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                                                End Date{' '}
                                              </label>
                                              <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden'>
                                                <input
                                                  type='date'
                                                  onClick={handleDateClick}
                                                  min={endDate2}
                                                  placeholder='Enter End Date'
                                                  {...register(
                                                    'eventListingTo',
                                                    {
                                                      required:
                                                        'End date is required',
                                                    }
                                                  )}
                                                  className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                                                />
                                              </div>
                                              {errors.eventListingTo && (
                                                <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                                  {
                                                    errors.eventListingTo
                                                      .message
                                                  }
                                                </p>
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      {formData.isContentMarketing && (
                                        <>
                                          <div className='mb-1'>
                                            <input
                                              type='text'
                                              placeholder='Number of Posts'
                                              {...register('noOfPosts', {
                                                required:
                                                  formData.isContentMarketing
                                                    ? 'Number of posts are required'
                                                    : false,
                                              })}
                                               onInput={(e) => {
                        e.currentTarget.value = e.currentTarget.value.replace(
                          /[^0-9]/g,
                          ''
                        );
                      }}
                                              className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                                errors.noOfPosts
                                                  ? 'border border-[#B91C1C]'
                                                  : 'border border-gray-300'
                                              }`}
                                              style={{
                                                outline: errors.noOfPosts
                                                  ? '2px solid red'
                                                  : 'none',
                                              }}
                                            />
                                            {errors.noOfPosts && (
                                              <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                                                {errors.noOfPosts.message}
                                              </p>
                                            )}
                                          </div>
                                          {/* <p className="flex items-center justify-center font-semibold text-gray-700 text-sm my-2">
                                    OR
                                  </p> */}
                                          {/* <div className="mt-3">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                      Trial end date{" "}
                                    </label>
                                    <div className="flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden">
                                      <input
                                        type="date"
                                        min={today}
                                        onClick={handleDateClick}
                                        // onChange={handleStartDateChange}
                                        placeholder="Enter Start Date"
                                        {...register("trialEndDate", {
                                          required: formData.isContentMarketing
                                            ? "Trial end Date is required"
                                            : false,
                                        })}
                                        className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                      />
                                    </div>
                                  </div>
                                  {errors.trialEndDate && (
                                    <p className="text-[#B91C1C] font-[500] text-sm mt-1">
                                      {errors.trialEndDate.message}
                                    </p>
                                  )} */}
                                        </>
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                </>
              )}
            </div>
            {/* <div className="w-35%"></div> */}
          </div>
          <div className='fixed bottom-[28px] w-[78%]'>
            <div
              className='flex justify-end  p-4 items-center  bg-white bottom-[20px]'
              style={{
                boxShadow: '0px -16px 50px 0px #0000000D',
              }}
            >
              <button
                type='submit'
                className={`px-4 py-2 border border-gray-300 text-gray-600  rounded-[8px] font-bold text-base mr-3`}
                onClick={usersScreen}
              >
                Cancel
              </button>
              <button
                type='submit'
                disabled={
                  !isAnyServiceSelected() || Object.keys(errors).length > 0 || isFieldInvalid || (!selectedPitched && convertBookForm === 'convertToBookingForm')
                }
                
                // disabled={!isValid || isSubmitting || isBollen}
                className={`px-4 py-2 gradient-background text-white rounded font-bold text-base ${
                  !isAnyServiceSelected() || Object.keys(errors).length > 0
                    ? 'opacity-50 cursor-not-allowed'
                    : ''
                } `}
                // className={`px-4 py-2 gradient-background text-white rounded font-bold text-base`}
              >
                {selectedTypes === 'INVITE'
                  ? 'Invite and Activate Dashboard'
                  : selectedTypes === 'TRIAL'
                  ? 'Activate Dashboard'
                  : userId && companyName
                  ? 'Confirm'
                  : userId && convertBookForm === 'EditconvertToBookingForm'
                  ? 'Update Order Form'
                  : userId && name === 'converToProposals'
                  ? 'Convert & Share Proposal'
                  : userId && convertBookForm
                  ? 'Submit and Share Order Form'
                  : userId
                  ? 'Update Proposal'
                  : 'Save Proposal'}
                {/* {userId ? "Update Proposal" : "Save Proposal"} */}
              </button>
            </div>
          </div>
        </div>
      </form>
      {isPopupOpen && (
        <ConfirmationModal
          onClose={handleClosePopup}
          onConfirm={handleConfirm}
          isUpdate={
            selectedTypes === 'INVITE' && submittedData?.dataType === 'VENDOR'
              ? 'INVITE'
              : selectedTypes === 'INVITE' &&
                submittedData?.dataType !== 'VENDOR'
              ? 'adminInvite'
              : selectedTypes === 'TRIAL' &&
                submittedData?.dataType === 'VENDOR'
              ? 'TRIAL'
              : selectedTypes === 'TRIAL' &&
                submittedData?.dataType !== 'VENDOR'
              ? 'adminTrail'
              : userId && convertBookForm === 'EditconvertToBookingForm'
              ? 'updateConfirmBooking'
              : userId && convertBookForm
              ? 'confirmBook'
              : searchParams.size !== 0 && name !== ''
              ? 'update'
              : 'submit'
          }
          nameOfScreen={nameOfScreen}
          statusValue={submittedData?.status || ''}
        />
      )}
      {isShow && (
        <Sucesspopup
          addUser={closePopup}
          viewUser={viewUsers}
          emailId={submittedData?.email || ''}
          isUpdate={
            selectedTypes === 'INVITE' && submittedData?.dataType === 'VENDOR'
              ? 'INVITE'
              : selectedTypes === 'INVITE' &&
                submittedData?.dataType !== 'VENDOR'
              ? 'adminInvite'
              : selectedTypes === 'TRIAL' &&
                submittedData?.dataType === 'VENDOR'
              ? 'TRIAL'
              : selectedTypes === 'TRIAL' &&
                submittedData?.dataType !== 'VENDOR'
              ? 'adminTrail'
              : userId && convertBookForm === 'EditconvertToBookingForm'
              ? 'updateConfirmBooking'
              : userId && convertBookForm
              ? 'confirmBook'
              : userId
              ? 'update'
              : 'add'
          }
          nameOfScreen='proposals'
          statusValue={submittedData?.status || ''}
          download={function (): void {
            throw new Error('Function not implemented.');
          }}
          upload={function (): void {
            throw new Error('Function not implemented.');
          }}
          confirm={function (): void {
            throw new Error('Function not implemented.');
          }}
        />
      )}
    </div>
  );
};

export default AddProposal;
